import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toTitleCase } from "../../shared/util/utils";
import { Guess } from "../../types/Guess.type";
import { Run, RunID } from "../../types/Run.type";
import { User, UserID } from "../../types/User.type";
import { logOut, selectUserId } from "../Authentication/Authentication.store";
import { AvatarIconLarge, AvatarIconSized } from "../AvatarCreator/AvatarIcon";
import { DropDownUpIcon, DropDownIcon } from "../../shared/icons/Dropdown";
import { ReactComponent as EditIcon } from "../../shared/icons/EditIcon.svg";
import "./ProfilePage.scss";
import RunRecord from "./RunRecord";

interface UserInfoProps {
    user: User,
    scoreRecordOrganized: Record<RunID, Guess[]>,
    runRecordOrganized: Record<RunID, Run>
}

const UserInfo: React.FC<UserInfoProps> = ({ user, scoreRecordOrganized, runRecordOrganized }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentUserId: UserID | null = useSelector(selectUserId);
    const [ editing, setEditing ] = useState<boolean>(false);

    const logoutUser = () => {
        dispatch(logOut()); 
        navigate('/login');
        window.localStorage.removeItem('gp-user');
    }

    return (
        <div className="column w-100 max-w-500" id="user-info">
            <div className="row align-center mx-10 my-10">
                <div className="avatar-container">
                    <AvatarIconSized {...user.avatar} size={60} />
                    { editing && <><div className="white-circle" /><EditIcon className="pointer edit-icon" onClick={() => {navigate('/avatar-creator')}}/></> }
                </div>
                <p className="title m-0 mx-10">{user.username}</p>
                { currentUserId === user.id && 
                    <div className="row--end flex-grow mx-bw-5">
                        { user.admin && <Link to="/admin">Admin</Link> }
                        <p className="pointer m-0" onClick={() => {editing ? setEditing(false) : setEditing(true)}}>{editing ? 'Save' : 'Edit'}</p>
                        <p className="pointer m-0" onClick={logoutUser}>Logout</p>
                    </div>
                }
            </div>
            <RunRecord scoreRecordOrganized={scoreRecordOrganized} runRecordOrganized={runRecordOrganized} />
        </div>
    )
}

export default UserInfo;
